import {resolvePublicApiBaseUrl} from '@fitro/customer-host/api'

export function resolvePublicAssetUrl(value?: string | null): string | null {
    const trimmed = value?.trim()
    if (!trimmed) return null
    if (/^https?:\/\//i.test(trimmed)) return trimmed
    if (/^[a-z][a-z\d+.-]*:/i.test(trimmed) || trimmed.startsWith('//')) return null

    const base = resolvePublicApiBaseUrl()?.replace(/\/$/, '')
    return base ? `${base}${trimmed.startsWith('/') ? trimmed : `/${trimmed}`}` : trimmed
}
